import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {User} from "@app/auth/user.model";

@Injectable()
export class AuthService {

    user = new BehaviorSubject<User>(null);


    //funkcija za logovanje iz Proventuma, dok se aplikacija skroz ne odvoji
    setUser(user: { id: number, first_name: string, last_name: string, email: string, avatar: string }) {
        return new Promise((resolve, reject) => {
            const loggedInUser = new User(
                user.id,
                user.first_name,
                user.last_name,
                user.email,
                user.avatar);
            this.user.next(loggedInUser);
            resolve(true);
        })

    }

    parseJwt(token) {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            return JSON.parse(jsonPayload).sub;
        } catch (e) {

        }

    };

}
